import { inject, Injectable } from '@angular/core';
import { BaseApiService } from '../base-api-service/base-api.service';
import { TokenService } from '../../auth/token-service/token.service';

const RESOURCE = '/v1/system-events';

@Injectable({
    providedIn: 'root',
})
export class AuditLogsService extends BaseApiService {
    tokenService = inject(TokenService);

    logLogout(): void {
        this.logger.debug(`AuditLogsService: logLogout() called.`);
        const path = `/logout`;
        // Use fetch to keep alive if browser closes
        fetch(this.apiUrl + RESOURCE + path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${this.tokenService.getToken()}`,
            },
            keepalive: true,
        });
    }
}
